import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import Scrollbar from 'react-smooth-scrollbar';
import SidebarContent from './SidebarContent';

export default connect(state => ({ collapse: state.App.Sidebar.collapse }))((props) => {
    const sidebarClass = classNames({
        sidebar: true,
        'sidebar--collapse': props.collapse,
    });
    return (
        <div className={sidebarClass}>
            <div className="sidebar__back" />
            <Scrollbar className="sidebar__scroll scroll">
                <div className="sidebar__wrapper sidebar__wrapper--desktop">
                    <SidebarContent onClick={() => {}} />
                </div>
            </Scrollbar>
        </div>
    );
});



// WEBPACK FOOTER //
// ./src/modules/App/components/sidebar/Sidebar.js